module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r3n4r8r-7c92b115ae41b612fefa74441e9e6066.svg";